import "./Footer.css"

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <p>&copy; 2025 Arbaz Ali Shaikh. All rights reserved.</p>
          <p>Built with React JS</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
